import React from 'react';

import UniqueId from '../../../services/uid/UniqueId';

import FormControlContainer from './FormControlContainer';

interface FormProps {
  id: UniqueId;
  rootControlId: UniqueId;
}

const Form: React.FC<FormProps> = ({ id, rootControlId }) => (
  <FormControlContainer name={rootControlId} formId={id} />
);

export default Form;
